/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

// library imports
import { Component } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

// project imports
import { LocationsList, SalesListForLocation } from 'features/components/base/public';

/**
 * routing for location components
 * 
 * @param props
 * 
 * @return routing for location components
 * 
**/

export class LocationsRouter extends Component {

    render() {
        return (
            <Switch>
                <Route exact path={["/locations", "/my-location"]} render={(routeProps) => (<LocationsList key={routeProps.location.pathname} {...routeProps} /> )}/>   
                    <Route exact path={[`/estate-sales/:locationstatecode/:locationcode`, `/estate-sales/:locationstatecode`]} component={SalesListForLocation} />

                <Redirect to="/" />
            </Switch>
        );
    }
}
